import { useState, useEffect, useCallback } from 'react';

const isTouchDevice = () => {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
};

export const useMobilePortrait = () => {
  const [isMobilePortrait, setIsMobilePortrait] = useState(false);

  const checkMobilePortrait = useCallback(() => {
    const isPortrait = window.matchMedia('(orientation: portrait)').matches;
    const isMobileSize = window.matchMedia('(max-width: 767px)').matches;
    const isTouch = isTouchDevice();
    setIsMobilePortrait(isPortrait && isMobileSize && isTouch);
  }, []);

  useEffect(() => {
    window.addEventListener('resize', checkMobilePortrait);
    checkMobilePortrait(); // Initial check

    return () => window.removeEventListener('resize', checkMobilePortrait);
  }, [checkMobilePortrait]);

  return isMobilePortrait;
};

